module.exports = __webpack_public_path__ + "static/media/logo-2line.b665acd5.svg";